// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarRating__stars___bpMfb"};